import moment from "moment";
export const apiUrl = "https://api.bermudasportsradar.com";
// export const apiUrl = "https://z4sgbc3v-5002.inc1.devtunnels.ms";
// live 1

export const s3Url = "https://bermuda-sports.s3.us-east-2.amazonaws.com";
export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

export const apiHeader = (token, isFormData) => {
  const headers = {
    "ngrok-skip-browser-warning": "69420",
    "timezone-offset": moment().utcOffset(),
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return { headers };
};

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};

export const falsyArray = [
  null,
  undefined,
  "",
  0,
  false,
  NaN,
  "null",
  "undefined",
  "false",
  "0",
  "NaN",
];
